import { Constant } from "../../../constants/constant";

export function propsToInitialState(data, linhVucList) {
  const dataInit = { ...data };
  dataInit.phanLoai = Constant?.CAP?.find(item => item?.id === data?.cap) || null;
  dataInit.linhVuc = linhVucList?.find(item => item?.id === data?.idLinhVuc) || null;
  return dataInit;
}

export function parseDataSave(value, profile) {
  const dataSave = { ...value };
  dataSave.cap = value?.phanLoai?.id || 0;
  dataSave.idLinhVuc = value?.linhVuc?.id || 0;
  dataSave.linhvuc = value?.linhVuc?.ten || "";
  dataSave.idDoanhNghiep = profile?.idDoanhNghiep || 0;
  return dataSave;
}
